module.exports = __webpack_public_path__ + "img/997.16f3ed7f.png";